import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface Drug {
  code: string;
  name: string;
  nameEn: string;
  activeIngredient: string;
}

export interface PrescriptionItem {
  AutoIndex?: number;
  PrescriptionID?: number;
  DrugName: string;
  DrugCode?: string;
  Dosage: string;
  Unit?: string;
  Route?: string;
  TimingCode?: string;
  FrequencyCode?: string;
  FrequencyCustom?: string;
  IntervalValue?: number;
  IntervalUnit?: string;
  Instructions?: string;
}

export interface Prescription {
  AutoIndex?: number;
  PID: string;
  GID: number;
  UID?: number;
  Opener?: string;
  OpenerTitle?: string;
  OpenerEngName?: string;
  ExamID?: number;
  CreatedAt?: string;
  SignedAt?: string;
  Status?: string;
  IsNarcotic?: boolean;
  DoctorID?: string;
  NarcoticInstructions?: string;
  PatFirst?: string;
  PatLast?: string;
  PatIDNum?: string;
  PatDOB?: string;
  items?: PrescriptionItem[];
}

@Injectable({
  providedIn: 'root'
})
export class PrescriptionService {

  constructor(private http: HttpClient) {}

  searchDrugs(q: string): Observable<Drug[]> {
    return this.http.get<Drug[]>(`/api/prescriptions/drugs?q=${encodeURIComponent(q)}`);
  }

  create(pid: string, gid: number, examID?: number): Observable<{ AutoIndex: number }> {
    return this.http.post<{ AutoIndex: number }>('/api/prescriptions', { PID: pid, GID: gid, ExamID: examID || null });
  }

  getAll(pid: string, gid: number): Observable<Prescription[]> {
    return this.http.get<Prescription[]>(`/api/prescriptions/${pid}/${gid}`);
  }

  getOne(id: number): Observable<Prescription> {
    return this.http.get<Prescription>(`/api/prescriptions/single/${id}`);
  }

  addItem(prescriptionId: number, item: PrescriptionItem): Observable<{ AutoIndex: number }> {
    return this.http.post<{ AutoIndex: number }>(`/api/prescriptions/${prescriptionId}/items`, item);
  }

  removeItem(prescriptionId: number, itemId: number): Observable<any> {
    return this.http.delete(`/api/prescriptions/${prescriptionId}/items/${itemId}`);
  }

  sign(prescriptionId: number): Observable<any> {
    return this.http.post(`/api/prescriptions/${prescriptionId}/sign`, {});
  }

  updateStatus(prescriptionId: number, status: string): Observable<any> {
    return this.http.put(`/api/prescriptions/${prescriptionId}/status`, { status });
  }

  saveNarcotic(prescriptionId: number, data: { IsNarcotic: boolean; DoctorID: string; NarcoticInstructions: string }): Observable<any> {
    return this.http.put(`/api/prescriptions/${prescriptionId}/narcotic`, data);
  }

  deletePrescription(prescriptionId: number): Observable<any> {
    return this.http.delete(`/api/prescriptions/${prescriptionId}`);
  }
}
